export enum CourseModuleTypeDto {
  Introduction,
  Quiz,
  Video,
  Complete,
  Survey,
}
